export const UsersRoutes = {
  FilterByCompanyUsers: '/users/?filterby=companyusers',
  FilterByPayrollManagers: '/users/?filterby=payrollmanagers',
};
